import React from 'react';

import clsxm from '@/lib/clsxm';

import MoneyFormat from '@/components/MoneyFormat';
import Typography from '@/components/typography';

import { Job } from '@/services/public-jobs.service';
import { routes } from '@/utils/route-utils';

export type CardHighPayingJobProps = {
  job: Pick<
    Job,
    | 'id'
    | 'location'
    | 'shift'
    | 'specialty'
    | 'weeklyPay'
    | 'discipline'
    | 'disciplineTitle'
    | 'title'
    | 'code'
  >;
  className?: string;
};

export default function CardHighPayingJob({
  job,
  className,
}: CardHighPayingJobProps) {
  return (
    <a
      className={clsxm(
        'flex min-w-[242px] flex-shrink-0 flex-col rounded-lg bg-white px-4 py-6 drop-shadow',
        className
      )}
      href={routes.jobFull(job)}
    >
      <Typography.Subtitle2 weight='bold' className='whitespace-nowrap'>
        {job.location.city}, {job.location.state} -{' '}
        <MoneyFormat value={job.weeklyPay} />
        /wk
      </Typography.Subtitle2>
      <Typography.Subtitle3 weight='bold'>
        {job.disciplineTitle}
      </Typography.Subtitle3>
      <Typography.Subtitle3 weight='normal'>
        {job.specialty}
      </Typography.Subtitle3>

      <Typography.Subtitle3 weight='normal'>{job.shift}</Typography.Subtitle3>
    </a>
  );
}
